module.exports.default = {
    "ORDER": "Ordine",
    "SCHEDULE.YOU_ARE_ALL_SET": "È tutto pronto!",
    "SCHEDULE.YOUR_DELIVERY_IS_SCHEDULED_FOR": "La consegna è prevista per",
    "SCHEDULE.CUSTOMER_#_MESSAGE": "Salve #, si prega di programmare la consegna",
    "SCHEDULE.SCHEDULE_NOW": "Pianifica ora",
    "SCHEDULE.DELIVERY_STATUS_UPDATES": "Consegna e aggiornamenti di stato",
    "SCHEDULE.EMAIL_UPDATES": "Aggiornamenti via e-mail",
    "SCHEDULE.SMS_UPDATES": "Aggiornamenti via SMS",
    "SCHEDULE.DISABLE_UPDATES": "Non desidero ricevere aggiornamenti.",
    "SCHEDULE.STATUS_UPDATE_IN_THE_FOLLOWING": "Desidero ricevere lo stato aggiornato sulla mia consegna nei seguenti canali:",
    "OOPS": "Oops!",
    "SOMETHING_WENT_WRONG": "Qualcosa è andato storto.",
    "REFRESH": "Aggiorna",
    "PAGE_NOT_FOUND": "Pagina non trovata",
    "COULD_NOT_FIND_PAGE": "Non siamo riusciti a trovare la pagina che cercavate.",
    "TRACKING.MESSAGE_DRIVER_FAILED": "Impossibile inviare un messaggio vuoto",
    "TRACKING.MESSAGE_DRIVER_PLACEHOLDER": "Inserisci il tuo messaggio all'autista",
    "TRACKING.SEND": "Invia",
    "TRACKING.ARRIVING_AT": "Arrivo in",
    "TRACKING.ETA": "Tempo stimato di arrivo",
    "TRACKING.MIN": "min",
    "TRACKING.MAP": "Mappa",
    "TRACKING.SATELLITE": "Satellite",
    "TRACKING.TERRAIN": "Terreno",
    "TRACKING.DRIVER_ARRIVED_MESSAGE": "Ehi, sono arrivato!",
    "TRACKING.DRIVER_ARRIVED_AT_MESSAGE": "has arrived at",
    "COMPLETED": "Order was scheduled\n",
    "RATING.SKIP": "Salta",
    "RATING.WHAT_WENT_WELL": "Cosa è andato bene?",
    "RATING.WHAT_WENT_WRONG": "Cosa è andato storto?",
    "RATING.THANK_YOU": "Grazie",
    "RATING.FOR_USING_OUR_SERVICE": "Grazie per aver utilizzato il nostro servizio!",
    "RATING.HOW_WAS_YOUR_DELIVERY": "Com'è stata la vostra esperienza di consegna?",
    "RATING.WHAT_WAS_YOUR_EXPERIENCE": "Aiutateci a migliorare valutando la vostra esperienza",
    "SCHEDULE.RATE_US": "Valutateci!",
    "TERM_OF_USE": "Termini di utilizzo",
    "PRIVACY_POLICY": "Informativa sulla privacy",
    "SHARING_MY_LOCATION": "Condividere la mia posizione",
    "SHARING_LOADING": "Condivisione del carico...",
    "REQUIRED_FIELD_MESSAGE": "Questo campo è obbligatorio",
    "CONTACT_NAME": "Contatto",
    "PHONE_NUMBER": "Numero di telefono",
    "EMAIL_ADDRESS": "Indirizzo E-Mail",
    "SEND": "Invia",
    "FORWARD.THIS_ORDER": "Inoltrare la consegna",
    "FORWARD.TO_CONTACT": "Inoltrare al contatto",
    "FORWARD.ARE_YOU_SURE_MESSAGE": "Siete sicuri di voler inoltrare questo ordine?",
    "FORWARDED.HAS_DELIVERY_FORWARDED_DELIVERY": "vi ha inoltrato una consegna",
    "FORWARDED.ARE_YOU_SURE_MESSAGE": "Siete sicuri di voler rifiutare questo ordine?",
    "ACCEPT": "Accetta",
    "REJECT": "Rifiuta",
    "PICKUP.SET_PICKUP_TIME": "Sono sulla mia strada",
    "PICKUP.IVE_ARRIVED": "Sono arrivato",
    "PICKUP.PICKUP_ETA_SET_FAILED": "Ops, qualcosa è andato storto.\n",
    "PICKUP.ETA_SET_FAILED_DESCRIPTION": "Riprova.",
    "PICKUP.MIN": "min",
    "PICKUP.SHOW_THIS_NUMBER": "Mostra questo numero all'addetto per ricevere il tuo ordine",
    "PICKUP.IM_OUTSIDE": "Sono qui",
    "PICKUP.LET_THEM_KNOW_YOUR_OUTSIDE?": "Facci sapere quando sei qui.",
    "PICKUP.I_WILL_ARRIVE_AT": "Arriverò alle",
    "PICKUP.PICKUP_ETA_SUCCESSFULLY_SET": "Orario di ritiro impostato con successo",
    "PICKUP.IN": "In",
    "PICKUP.TO": "A",
    "PICKUP.COLLECT": "Ordine ritirato",
    "PICKUP.SELECT_METHOD_OF_TRANSPORT": "Seleziona il metodo di trasporto",
    "PICKUP.CONFIRM_METHOD_OF_TRANSPORT": "Conferma il metodo di trasporto",
    "PICKUP.CANCEL": "Annulla",
    "PICKUP.CONFIRM_TIME": "Conferma l'orario di arrivo per il ritiro",
    "TRACKING.DRIVER_ROUTE_ONE_STOP_MESSAGE": "Il conducente è attualmente ad una fermata di distanza da voi",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART2": "fermate di distanza da voi",
    "TRACKING.DRIVER_ROUTE_STOPS_MESSAGE_PART1": "Il conducente è attualmente",
    "PICKUP.OK": "OK",
    "PICKUP.NEXT": "Avanti",
    "PICKUP.SKIP": "Salta",
    "CAR_ARRIVED.TITLE": "Ultimo passaggio! Facci sapere come trovarti:",
    "CAR_ARRIVED.PARKING_SPOT": "Area di parcheggio / Numero posto",
    "CAR_ARRIVED.LICENSE_PLATE": "Targa",
    "CAR_ARRIVED.VEHICLE_MODEL": "Modello e marca del veicolo",
    "CAR_ARRIVED.VEHICLE_COLOR": "Colore del veicolo",
    "CAR_ARRIVED.REMEMBER": "Ricorda i dettagli del mio veicolo",
    "CAR_ARRIVED.PARKING_SPOT_EXAMPLE": "(Esempio: C - 49)",
    "CAR_ARRIVED.LICENSE_PLATE_EXAMPLE": "(Esempio: 195-QUD)",
    "CAR_ARRIVED.VEHICLE_MODEL_EXAMPLE": "(Esempio: Ford Bronco)",
    "CAR_ARRIVED.VEHICLE_COLOR_EXAMPLE": "(Esempio: Blu)",
    "REDIRECT_PICKUP.TO": "A",
    "REDIRECT_PICKUP.CONFIRM_TITLE": "Cambiare il luogo di ritiro?",
    "REDIRECT_PICKUP.SUCCESS_TITLE": "Luogo di ritiro modificato con successo",
    "REDIRECT_PICKUP.FAILED_TITLE": "Impossibile cambiare il luogo di ritiro",
    "REDIRECT_PICKUP.FAILED_DESCRIPTION": "Qualcosa è andato storto",
    "REDIRECT_PICKUP.OK": "OK",
    "REDIRECT_PICKUP.KM": "km",
    "REDIRECT_PICKUP.SELECT_PICKUP_LOCATION": "Seleziona il luogo di ritiro",
    "REDIRECT_PICKUP.SET_AS_PICKUP_LOCATION": "Imposta come luogo di ritiro",
    "REDIRECT_PICKUP.PICKUP_OPTIONS": "Opzioni di ritiro",
    "SOON": "Presto",
    "TRACKING.WANT_TO_CALL_YOUR_DRIVER": "Vuoi chiamare il tuo autista?",
    "GLOBAL.CALL": "Chiama",
    "GLOBAL.CANCEL": "Annulla",
    "﻿PICKUP.SET_PICKUP_TIME": "Sono in arrivo",
    "RATING.PROOF_OF_DELIVERY_MESSAGE": "Il tuo ordine ti sta aspettando proprio fuori dalla tua porta!",
    "SCHEDULED.THANKS_FOR_USING": "Grazie per aver utilizzato {{merchant_name}}",
    "SCHEDULED.SHIPMENT_IN_TRANSIT": "La tua spedizione {{external_id}} è in transito",
    "SCHEDULED.YOUR_DELIVERY_IS_SCHEDULED_FOR": "Il tuo ordine è programmato per",
    "Submit": "Invia",
    "RATING.SELECT_STARS_BEFORE_SUBMIT": "Per votare, seleziona prima le stelle",
    "PICKUP.SHOW_ID": "Mostra ID",
    "TRACKING.ESTIMATED_TIME_ARRIVAL": "Tempo stimato di arrivo",
    "OPEN_MENU": "Apri menu",
    "CLOSE_MENU": "Chiudi menu",
    "MAP_AUTO_CENTER": "Mappa del centro auto",
    "MAP_SETTINGS": "Impostazioni mappa",
    "ZOOM_OUT": "Zoom indietro",
    "ZOOM_IN": "Zoom avanti",
    "TRACKING.CALL_DRIVER": "Chiamare l'autista",
    "TRACKING.MESSAGE_DRIVER": "Messaggio il driver",
    "PICKUP.SELECT_TIME_TO_CONFIRM": "Conferma l'orario di arrivo per il ritiro",
    "PICKUP.SET_OR_ARRIVE_DESCRIPTION": "Non vogliamo farti aspettare.\nFacci sapere quando sei in arrivo o stai arrivando:",
    "SCHEDULE.TIME_ZONE_TEXT": "Fuso orario",
    "TRACKING.THANKS_MESSAGE_SUBTITLE": "Ci stiamo lavorando!",
    "TRACKING.THANKS_MESSAGE_TEXT": "Stiamo raccogliendo i tuoi articoli e un membro del team uscirà a breve dalla tua auto",
    "TRACKING.THANKS_MESSAGE_TITLE": "Grazie per esserti registrato",
    "TRACKING.CLICK_COLLECT_MESSAGE_TEXT": "Vai al punto di raccolta in negozio dove il tuo ordine è pronto per il ritiro",
    "CANCEL_ORDER": "Annulla ordine",
    "CANCELLATION_VALIDATION_TITLE": "Sei sicuro di voler annullare questo ordine?",
    "CANCELLATION_VALIDATION_BACK": "Indietro",
    "CANCELLATION_VALIDATION_YES": "Sì, per favore",
    "CANCEL_SUCCESS": "Abbiamo annullato il tuo ordine",
    "CANCEL_PAST_ALLOWED": "Cancellazione dell'ordine scaduta",
    "CANCEL_ERROR": "Non siamo riusciti ad annullare il tuo ordine",
    "RATING.FREE_TEXT_COMMENT": "Dicci di più",
    "RATING.ORDER_DELIVERED_GREEN": "Abbiamo consegnato il tuo ordine con un veicolo ecologico",
    "CX_ORDER_STATUS.CONFIRMED": "Ordine confermato. Ci siamo su di esso.",
    "CX_ORDER_STATUS.RECEIVED": "Ordine Ricevuto. Saremo in contatto a breve.",
    "CX_ORDER_STATUS.FINDING_DRIVER": "Stiamo trovando un driver per il tuo ordine.",
    "CX_ORDER_STATUS.DRIVER_FOUND": "Abbiamo trovato il driver per il tuo ordine.",
    "CX_ORDER_STATUS.PICKING_UP": "Stiamo raccogliendo il tuo ordine in questo momento.",
    "CX_ORDER_STATUS.WAY_TO_PICKUP": "Siamo sulla buona strada per prendere il tuo ordine.",
    "CX_ORDER_STATUS.ON_PREVIOUS_DELIVERY": "Stiamo completando una consegna precedente prima del tuo ordine.",
    "CX_ORDER_STATUS.WAY_TO_DROPOFF": "Il tuo ordine è in arrivo ora!",
    "CX_ORDER_STATUS.ARRIVED": "Il tuo ordine è arrivato!",
    "TRACKING.DELIVERY_STATUS_TITLE": "Stato della consegna",
    "CONFIGURATION.TAGS.SHOW_DELIVERY_STATUS": "Mostra lo stato della consegna ai clienti",
    "CONFIRM": "Confermare",
    "FLOW_OPTIONS.TITLE": "Come vuoi raccogliere il tuo ordine?",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_LABEL": "Consegnato alla tua auto in un punto designato",
    "FLOW_OPTIONS.CURBSIDE_BUTTON_TEXT": "Marciapiede",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_LABEL": "Pickup in negozio o in una posizione impostata",
    "FLOW_OPTIONS.CLICK_AND_COLLECT_TEXT": "Fare clic e raccogliere",
    "RATING_STAR_ALT": "Seleziona fino a 5 stelle per inviare una valutazione",
    "RATING_STAR_ALT_ONE": "L'orario di arrivo stimato è di",
    "RATING_STAR_ALT_TWO": "stelle",
    "TRACKING.ARRIVING_IN_ARIA_LABEL": "L'orario di arrivo stimato è di",
    "TRACKING.MAP_CONTAINER_ARIA_LABEL": "Mappa per tracciare l'ordine",
    "SCHEDULE.EXTERNAL_ID_INFO": "Ordine ID: {{externalId}}",
    "SCHEDULE.TASK_NOTE_LABEL": "Commento",
    "SCHEDULE.CANCEL_NOTE_INPUT": "Cancella",
    "DELIVERY_WAS_CANCELLED": "Consegna annullata",
    "QUESTIONNAIRE.SKIP": "Salta",
    "QUESTIONNAIRE.SKIP_VALIDATION_HEADER": "Sei sicuro di voler saltare?",
    "QUESTIONNAIRE.SKIP_VALIDATION_MESSAGE": "Alcune domande non sono state risposte. Sei sicuro di voler continuare senza completarle?",
    "QUESTIONNAIRE.BACK": "Indietro",
    "QUESTIONNAIRE.SUBMIT_FAILED": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS": "",
    "QUESTIONNAIRE.NA_VALUE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_TITLE": "",
    "QUESTIONNAIRE.SUBMIT_SUCCESS_MESSAGE": "",
    "QUESTIONNAIRE.PROGRESS_BAR_TITLE": "",
    "QUESTIONNAIRE.NEXT": "",
    "QUESTIONNAIRE.INVALID_FORMAT": "",
    "RESCHEDULE.NEED_A_DIFFERENT_TIME": "Ti serve un altro orario?",
    "RESCHEDULE.RESCHEDULE_YOUR_DELIVERY": "Riprogramma la tua consegna",
    "RESCHEDULE.GREETING": "Ciao 👋 Sono l'assistente per la riprogrammazione di {{merchant_name}}. Il tuo ordine #{{order_id}} è programmato per {{delivery_window}}.\n\nVuoi cambiare la fascia oraria di consegna? Seleziona un'opzione qui sotto e ci pensiamo noi.",
    "RESCHEDULE.FIRST_AVAILABLE": "Primo disponibile",
    "RESCHEDULE.SAME_DAY": "Stesso giorno, orario diverso",
    "RESCHEDULE.PICK_A_DATE": "Scegli una data",
    "RESCHEDULE.NEAREST_WINDOWS": "Ecco le fasce orarie disponibili più vicine. Seleziona la data che preferisci",
    "RESCHEDULE.WINDOWS_FOR_DATE": "Ecco tutte le fasce orarie disponibili per il {{date}}. Seleziona quella che preferisci",
    "RESCHEDULE.WHICH_DATE": "Quale data preferisci?",
    "RESCHEDULE.NO_WINDOWS": "Spiacenti, non ci sono fasce orarie disponibili per quel giorno. Prova con un'altra data",
    "RESCHEDULE.NO_WINDOWS_AVAILABLE": "Spiacenti, al momento non ci sono fasce orarie disponibili per la riprogrammazione.",
    "RESCHEDULE.SOMETHING_WENT_WRONG": "Si è verificato un errore durante il caricamento delle fasce orarie disponibili. Riprova.",
    "RESCHEDULE.TRY_AGAIN": "Riprova",
    "RESCHEDULE.BACK_TO_START": "Torna all'inizio",
    "RESCHEDULE.BACK_TO_DELIVERY": "Torna alla mia consegna",
    "RESCHEDULE.CONFIRMED": "Tutto fatto! La consegna è ora programmata per {{delivery_window}}. Buona giornata!",
    "RESCHEDULE.TYPE_A_MESSAGE": "Scrivi un messaggio",
    "RESCHEDULE.TODAY": "Oggi"
};
	